import React, {useEffect, useState} from 'react';
import { Flex} from "antd";
import {StyledCard} from "./PropertiesCard.styled";
import style from "./PropertiesCard.module.scss";
import {FaChevronLeft} from "react-icons/fa6";
import GuaranteePopup from "../guaranteePopup/GuaranteePopup";
import PropertiesPopup from "../propertiesPopup/PropertiesPopup";
import {PropertiesCardProps} from "../../models";
import {useLocation} from "react-router-dom";
const PropertiesCard = ({onConfirm}:PropertiesCardProps) => {
    const [open, setOpen] = useState<boolean>(false)
    const [chosenItems, setChosenItems] = useState<any>([])
    const location = useLocation();
    const openGuaranteeModal = () => {
        setOpen(true)
    }
    const onCansel = () => {
        setOpen(false)
    }
    useEffect(() => {
        if (location?.state?.stepTwoForm?.productProperties)
            setChosenItems(location?.state?.stepTwoForm?.productProperties)
    }, [location]);
    return (
    <>        <StyledCard className={'shadow-sm'} onClick={openGuaranteeModal}  >
            <Flex justify={"space-between"} align={"center"}>
                <Flex align={"center"} gap={"small"}>
                   <span>مشخصات</span>
                </Flex>
                <Flex gap={"small"} align={"center"}>
                    {chosenItems?.length > 0  && <span className={style.icons}>{chosenItems?.length} مورد انتخاب شده </span>}
                    <span> <FaChevronLeft  className={style.icons}/> </span>
                </Flex>

            </Flex>
        </StyledCard>
        <PropertiesPopup open={open} onCansel={onCansel} onConfirm={(form:any) => {
            onConfirm(form)
            setChosenItems(form)
        }}/>
    </>

);
};

export default PropertiesCard;
